import { alertController, IonicSafeString, AlertOptions } from '@ionic/core'

const deferred = () => {
  const result: any = {}
  result.promise = new Promise((resolve, reject) => {
    result.resolve = resolve
    result.reject = reject
  })
  return result
}

interface IAlertOptions extends AlertOptions {
  button?: string;
}

const alertLayer = (options: IAlertOptions | string) => {
  const theOptions = typeof options === 'string' ? {
    message: options
  } : options
  const buttonStr = theOptions.button || 'OK'
  const d = deferred()
  alertController.create(Object.assign({
    header: i18n.t('common.attention'),
    buttons: [
      {
        text: buttonStr,
        handler: () => {
          d.resolve(true)
        }
      }
    ]
  }, theOptions)).then(alert => {
    alert.present()
  })
  return d.promise
}

if (window.MX) {
  window.MX.alertLayer = alertLayer
}

export default alertLayer
